export function SecurityPrivacyPage({ copy, onGetStarted, onOpenHow, onOpenPricing }) {
  return (
    <article className="resource-page" lang={copy.locale}>
      <header className="resource-page-intro security-page-intro">
        <div className="security-page-intro-grid">
          <div className="security-page-intro-main">
            <div className="security-page-intro-copy">
              <p className="resource-page-kicker">{copy.kicker}</p>
              <h1 id="security-page-title" className="resource-page-title">
                {copy.title}
              </h1>
              <p className="resource-page-lead">{copy.lead}</p>
            </div>
            <section className="security-intro-protects" aria-labelledby="security-protects">
              <div className="resource-section-head">
                <h2 id="security-protects">{copy.protectsHeading}</h2>
              </div>
              <div className="resource-card-grid security-protects-grid">
                {copy.protectedItems.slice(0, 3).map((item) => (
                  <article key={item.title} className="resource-card">
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </article>
                ))}
              </div>
            </section>
          </div>
          <aside className="security-reassurance-panel" aria-label={copy.reassuranceAria}>
            <p className="security-reassurance-kicker">{copy.reassuranceKicker}</p>
            <h2 className="security-reassurance-title">{copy.reassuranceTitle}</h2>
            <ul className="security-reassurance-list">
              {copy.reassurancePoints.map((item) => (
                <li key={item.title} className="security-reassurance-item">
                  <span className="security-reassurance-mark" aria-hidden />
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div className="security-reassurance-flow" aria-label={copy.reassuranceFlowLabel}>
              {copy.reassuranceFlow.map((item, index) => (
                <span key={item} className="security-reassurance-step">
                  {item}
                  {index < copy.reassuranceFlow.length - 1 ? (
                    <span className="security-reassurance-arrow" aria-hidden>
                      →
                    </span>
                  ) : null}
                </span>
              ))}
            </div>
          </aside>
        </div>
      </header>

      <section className="resource-section" aria-labelledby="security-access">
        <div className="resource-section-head">
          <h2 id="security-access">{copy.principlesHeading}</h2>
        </div>
        <div className="security-principles-grid">
          {copy.principlesItems.map((item) => (
            <article key={item.title} className="security-principle-card">
              <span className="security-principle-icon" aria-hidden>
                ✓
              </span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="resource-section" aria-labelledby="security-contacts">
        <div className="resource-section-head">
          <h2 id="security-contacts">{copy.contactsHeading}</h2>
        </div>
        <div className="security-contacts-grid">
          {copy.trustedContacts.map((item) => (
            <article
              key={item.title}
              className={`resource-card security-contact-card${
                /cannot|ne peuvent pas/i.test(item.title) ? " security-contact-card-negative" : ""
              }`}
            >
              <h3>{item.title}</h3>
              <ul className="resource-mini-list">
                {item.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="resource-section" aria-labelledby="security-verification">
        <div className="resource-section-head">
          <h2 id="security-verification">{copy.verificationHeading}</h2>
          <p>{copy.verificationLead}</p>
        </div>
        <div className="security-flow-grid">
          {copy.verificationPaths.map((item, index) => (
            <article key={item.title} className="security-flow-card">
              <div className="security-flow-step">
                <span className="security-flow-number">{index + 1}</span>
                <h3>{item.title}</h3>
              </div>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="resource-section resource-callout-section" aria-labelledby="security-review">
        <div className="resource-section-head">
          <h2 id="security-review">{copy.reviewHeading}</h2>
        </div>
        <ul className="resource-check-list security-control-list">
          {copy.reviewPoints.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="resource-cta" aria-labelledby="security-cta">
        <div className="resource-cta-copy">
          <p className="resource-page-kicker">{copy.ctaKicker}</p>
          <h2 id="security-cta">{copy.ctaTitle}</h2>
          <p>{copy.ctaBody}</p>
        </div>
        <div className="resource-cta-actions">
          {typeof onGetStarted === "function" ? (
            <button type="button" onClick={onGetStarted}>
              {copy.primaryCta}
            </button>
          ) : null}
          {typeof onOpenHow === "function" ? (
            <button type="button" className="secondary" onClick={onOpenHow}>
              {copy.howCta}
            </button>
          ) : null}
          {typeof onOpenPricing === "function" ? (
            <button type="button" className="secondary" onClick={onOpenPricing}>
              {copy.pricingCta}
            </button>
          ) : null}
        </div>
      </section>
    </article>
  );
}
